import { CallTask } from '@/services/lifecycleAPI';

import { formatDateTime } from '../shared/format';
import { outcomeLabel } from '../shared/labels';

const HOUR = 3600 * 1000;
const DAY = 24 * HOUR;

export const isOverdue = (task: CallTask, now: Date = new Date()) =>
  task.status === 'open' && new Date(task.due_at).getTime() < now.getTime();

export const dueLabel = (task: CallTask, now: Date = new Date()): string => {
  if (!isOverdue(task, now)) return formatDateTime(task.due_at);
  const late = now.getTime() - new Date(task.due_at).getTime();
  const days = Math.floor(late / DAY);
  if (days >= 1) return `Overdue ${days} ${days === 1 ? 'day' : 'days'}`;
  const hours = Math.max(Math.floor(late / HOUR), 1);
  return `Overdue ${hours} ${hours === 1 ? 'hour' : 'hours'}`;
};

export const shiftsLabel = (count: number | null): string =>
  count === null ? '-' : `${count} open ${count === 1 ? 'shift' : 'shifts'}`;

export const resultNote = (task: CallTask): string => {
  if (task.status === 'open') return '';
  const when = formatDateTime(task.completed_at ?? task.updated_at);
  if (task.status === 'skipped') {
    const who = task.closed_by_system
      ? 'Closed by system'
      : `Closed by ${task.completed_by_name ?? 'an admin'}`;
    return `${who} · ${when}`;
  }
  const outcome = task.outcome ? ` · ${outcomeLabel(task.outcome)}` : '';
  return `${task.completed_by_name ?? 'An admin'} · ${when}${outcome}`;
};
